/** Name to display for credit */
export const CREDIT_DISPLAY_NAME = "token";

/** Name to display for credits */
export const CREDITS_DISPLAY_NAME = "tokens";

/** Used as key to save token balance in local storage while purchasing new tokens */
export const CREDITS_BALANCE = "creditBalance";

/**
 * Used as key to determine if new credit purchased
 * Set this key in session storage while redirection after purchase
 */
export const HAS_CREDIT_PURCHASED = "hasCreditPurchased";